import {
	performPutRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';

type PortalAnnouncementsType = {
	baseUrl: string;
	projectKey: string;
	canAgentsAdd: boolean;
};

type ProjectNameType = {
	baseUrl: string;
	projectKey: string;
	name: string;
};

type ProjectDescType = {
	baseUrl: string;
	projectKey: string;
	description: string;
};

type SaveLogoType = {
	baseUrl: string;
	projectKey: string;
	file: string;
};

type DeleteLogoType = {
	baseUrl: string;
	projectKey: string;
};

export const updatePortalAnnouncements = ({
	baseUrl,
	projectKey,
	canAgentsAdd,
}: PortalAnnouncementsType) =>
	performPutRequest(
		`${baseUrl}/rest/servicedesk/1/${projectKey}/settings/agent-announcements/${
			canAgentsAdd ? 'enable' : 'disable'
		}`,
	);

export const updateProjectName = ({ baseUrl, projectKey, name }: ProjectNameType) =>
	performPutRequest(`${baseUrl}/rest/servicedesk/1/servicedesk-data/${projectKey}/name`, {
		body: JSON.stringify({ name }),
	});

export const updateProjectDescription = ({ baseUrl, projectKey, description }: ProjectDescType) =>
	performPutRequest(`${baseUrl}/rest/servicedesk/1/servicedesk-data/${projectKey}/desc`, {
		body: JSON.stringify({ description }),
	});

export const uploadLogo = ({ baseUrl, projectKey, file }: SaveLogoType) =>
	performPostRequest(`${baseUrl}/rest/servicedesk/1/servicedesk-data/${projectKey}/viewport-logo`, {
		headers: { 'content-type': 'image/*' },
		body: file,
	});

// This function takes a file (Image not dataURI) and uploads it to the backend
// This returns a temporary img URL which is then passed to the frontend to render
// The second request (the put request) confirms this image as the portal img
// This then finalises the update - This was done to not change the rest endpoints
export const saveLogo = async ({ baseUrl, projectKey, file }: SaveLogoType) => {
	const response = await uploadLogo({ baseUrl, projectKey, file });
	await performPutRequest(`${baseUrl}/rest/servicedesk/1/servicedesk-data/${projectKey}/logo`, {
		body: JSON.stringify({
			enableCustomLookAndFeel: true,
			temporaryLogoId: response.temporaryLogoId,
		}),
	});
	return response.temporaryLogoUrl;
};

export const deleteLogo = ({ baseUrl, projectKey }: DeleteLogoType) =>
	performPutRequest(`${baseUrl}/rest/servicedesk/1/servicedesk-data/${projectKey}/logo`, {
		body: JSON.stringify({ enableCustomLookAndFeel: false }),
	});
